import React from 'react';
import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';

/**
 * SortableTh — a table head cell you can sort by (spec §3.5): a real button inside the <th>,
 * `aria-sort` on the <th>, an arrow that shows the direction. Keyboard and screen readers get the
 * native button; a numeric column (`numeric`) is right-aligned with its arrow in front of the label,
 * so the label ends on the same edge as the figures under it.
 *
 *   const [sort, setSort] = useState({ key: 'createdAt', dir: 'desc' });
 *   <thead><tr>
 *     <SortableTh sortKey="name" sort={sort} onSort={setSort}>Mijoz</SortableTh>
 *     <SortableTh sortKey="amount" sort={sort} onSort={setSort} numeric defaultDir="desc">Summa</SortableTh>
 *   </tr></thead>
 *
 * `sort` is { key, dir: 'asc' | 'desc' }; `onSort` receives the next { key, dir }. Clicking the
 * active column flips its direction; clicking another starts at `defaultDir` (default 'asc';
 * money and dates usually want 'desc'). Anything else passed (className, style, width, title) goes
 * to the <th>.
 */
function SortableTh({ sortKey, sort, onSort, numeric = false, defaultDir = 'asc', children, className = '', ...rest }) {
  const active = Boolean(sort) && sort.key === sortKey;
  const dir = active ? sort.dir : null;
  const Icon = !active ? ArrowUpDown : dir === 'asc' ? ArrowUp : ArrowDown;

  const click = () => {
    if (!onSort) return;
    onSort({ key: sortKey, dir: active ? (dir === 'asc' ? 'desc' : 'asc') : defaultDir });
  };

  return (
    <th
      scope="col"
      {...rest}
      className={[numeric ? 'ui-num' : '', className].filter(Boolean).join(' ') || undefined}
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button type="button" className="ui-th-sort" onClick={click}>
        <span>{children}</span>
        <Icon aria-hidden="true" />
      </button>
    </th>
  );
}

export default SortableTh;
